import React, { Component, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Card } from '../../components/card'
import { Collapse } from '../../components/collapse'
import forOwn from 'lodash/forOwn'
import { User } from '../../core/types'
import VehicleWithProductPackageListItem from './userVehicleListItem/VehicleWithProductPackageListItem'
import DefaultVehicleListItem from './userVehicleListItem/DefaultVehicleListItem'
import VehicleWithRefiListItem from './userVehicleListItem/VehicleWithRefiListItem'

export interface Props {
  user: User
}

export class UserVehicles extends Component<Props> {
  static displayName = 'UserVehicles'
  /*
  static propTypes = {
    user: PropTypes.shape({
      vehicles: PropTypes.shape({
        bought: PropTypes.array,
        buying: PropTypes.array,
        collection: PropTypes.array,
        messaging: PropTypes.array,
        offering: PropTypes.array,
        owned: PropTypes.array,
        refinanced: PropTypes.array,
        refinancing: PropTypes.array,
        selling: PropTypes.array,
        sold: PropTypes.array,
      }),
    }),
  }
  */

  internalUrl = (key, car) => {
    if (key === 'selling' && car.acceptedOfferId) {
      return `/offers/${car.acceptedOfferId}`
    }
    switch (key) {
      case 'collection':
      case 'owned':
        return `/vehicles/${car.id}`
      case 'refinanced':
      case 'refinancing':
        return `/refinance/${car.refiId}`
      case 'bought':
      case 'buying':
      case 'sold':
        return `/offers/${car.acceptedOfferId}`
      case 'offering':
        return `/offers/${car.offerId}`
      default:
        return null
    }
  }

  render() {
    const {
      user: { vehicles },
    } = this.props
    let sections: ReactNode[] = []
    forOwn(vehicles, (value, key) => {
      const lines = (value as any[]).map((vehicle, index) => {
        switch (key) {
          case 'withPackages':
            return (
              <VehicleWithProductPackageListItem
                key={index}
                user={this.props.user}
                productPackage={vehicle}
                internalUrl={this.internalUrl(key, vehicle)}
              />
            )
          case 'refinancing':
            return (
              <VehicleWithRefiListItem
                key={index}
                refi={vehicle}
                internalUrl={this.internalUrl(key, vehicle)}
              />
            )
          default:
            return (
              <DefaultVehicleListItem
                key={index}
                vehicleInfo={vehicle}
                internalUrl={this.internalUrl(key, vehicle)}
              />
            )
        }
      })

      if (key === 'collection' && lines.length > 0) {
        lines.push(
          <div key="collectionMenu" className="user-vehicles__collection">
            <span className="icon-menu user-vehicles__collection-icon" />
            <p className="user-vehicles__collection-content">
              View all cars in collection
            </p>
          </div>
        )
      }

      if ((value as any[]).length === 0) {
        // TODO-TS
        return null
      }

      const renameKey = (key) => {
        const renamedKeys = {
          owned: 'own',
          offering: 'offers',
          withPackages: 'packages',
        }
        const renamedKey = renamedKeys[key]

        if (renamedKey) return renamedKey
        return key
      }

      sections.push(
        <Collapse title={renameKey(key)} key={renameKey(key)}>
          {lines}
        </Collapse>
      )

      return sections
    })

    const { user } = this.props

    return (
      <Card title="Vehicles" gridClass="user-vehicles">
        <div className="user-vehicles__actions">
          {/* fresh=1: Add a Vehicle means start a deal. Without it
              ProductPackages::Create reuses the customer's existing
              quoted/selected package for whatever vehicle the agent enters,
              reopening that deal instead of opening a new one. */}
          <Link
            to={`/refiapp?userId=${user.id}&fresh=1`}
            className="button button-drive-america user-vehicles__add-btn"
          >
            <span style={{ fontSize: '1.8rem', lineHeight: 1 }}>+</span>
            Add a Vehicle
          </Link>
        </div>
        <div className="user-vehicles__line">
          {sections.length > 0 ? sections : 'No Vehicles'}
        </div>
      </Card>
    )
  }
}

export default UserVehicles
